import Vue from "vue";

import { formatTextCurrency } from "ice.fo.utils/NumberUtils";

Vue.prototype.$formatTextNumber = function (
  value,
  decimal = 0,
  emptyValue = "0"
) {
  const locale = this.$i18n?.locale || "vn";

  if (!value) {
    return emptyValue;
  }

  value = `${value}`;

  if (value == "-") {
    return "-";
  }

  // const num = !decimal ? parseInt(value) : parseFloat(value);
  // console.log(num, 'num format:::', hasEndDot, decimal)
  let result = !decimal ? parseInt(value) : parseFloat(value);
  if (locale === "vn") {
    result = result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // Android and Iphone SE format number not work toLocaleString() function
  // if (this.$$isIOS) {
  //   result = NumberUtils.formatTextNumber(value, decimal, emptyValue)
  //   // console.log(result, 'after format::: ios')
  // } else {
  //   result = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  //   // console.log(result, 'after format::: android')
  // }

  return result;
};

Vue.prototype.$formatShortCurrency = function (value) {
  const locale = this.$i18n?.locale || "vn";
  const unit = locale === "vn" ? "K" : "$";
  if (!value) return `0${unit}`;

  let result = value;
  if (locale === "vn") {
    result = `${(result / 1000).toFixed(0)}${unit}`;
  } else {
    result = `${unit}${result}`;
  }

  return result;
};

Vue.prototype.$currency = function (value) {
  return formatTextCurrency(value);
};
